import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // NOTE: withCredentials is intentionally OFF. The preview CDN responds with
  // `Access-Control-Allow-Origin: *`, which browsers reject when credentials
  // are attached — breaking cross-origin flows (e.g. when the frontend is
  // served from a different preview host than REACT_APP_BACKEND_URL).
  // We rely on the Bearer token attached by the interceptor below.
});

// Also attach bearer token as fallback for cross-site restrictions
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function fileUrl(path) {
  const token = localStorage.getItem("token");
  return `${API}/files/${path}?auth=${encodeURIComponent(token || "")}`;
}
